import React from 'react';
import { useSelector } from 'react-redux';
import { Box, List, Typography } from '@drone-js/core';
import { getImageUrl } from 'core/utils/activityUrlGenerator';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import ContentArea from 'component/common/ContentArea/ContentArea';

const PageNotFoundErrorPage: React.FC = (props) => {
    const cms = useSelector(selectCmsFromBootstrap);
    // React.useEffect(() => {
    //      props.visit(); Please use track<T>() instead when you need to send analytics event.
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, []);

    return (
        <ContentArea px="8" py="12" max={50} display="flex" alignItems="center" justifyContent="center">
            <List data-element-name="page-not-found-error-page">
                <Box display="flex" py="16" justifyContent="center">
                    {/* eslint-disable-next-line @agoda/agoda-a11y/no-non-drone-image -- @agoda/agoda-a11y/no-non-drone-image[7d27e95e-66dc-4e98-9c0e-500cd0a80c14] */}
                    <img alt={cms[134380]} src={getImageUrl('page-not-found.svg')} />
                </Box>
                <Box px="32" display="flex" justifyContent="center">
                    <Typography variant="body-default" key="PageNotFound__Error__Message" textAlign="center">
                        {cms[134380]}
                    </Typography>
                </Box>
            </List>
        </ContentArea>
    );
};

PageNotFoundErrorPage.displayName = 'PageNotFoundErrorPage';
export default PageNotFoundErrorPage;
